import { IsString, IsOptional, MaxLength, IsInt, IsArray, MinLength } from 'class-validator';

export class ManuscriptSearchDTO {

    @IsOptional()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    content: string;

    @IsOptional()
    @IsInt()
    type: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    product: Array<string>;

}
